import UserLayout from '../views/account/Layout'
import UserIndex from '../views/account/Index'

export const accountRouters = {
  path: 'account',
  name: 'UserLayout',
  component: UserLayout,
  redirect: '/',
  children: [
    {
      path: '',
      name: 'Profile',
      component: UserIndex
    }
  ]
}
